import "prismjs/components/prism-c";
import "prismjs/components/prism-cpp";
